// extracted by mini-css-extract-plugin
export default {"blogCategoriesContainer":"styles-module__[local]___ubgPI"};